import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAnonymousUserAction,
  // selectUserId,
  selectLoadingUser,
  selectUserId,
} from "./playerSlice";
import { CircularProgress, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

const LoadingGrid = styled(Grid)(({ theme }) => ({
  width: "100%",
  height: "100%",
  minHeight: "300px",
}));

const AnonymousUserWrapper = (props) => {
  const dispatch = useDispatch();

  const userId = useSelector(selectUserId);
  const loading = useSelector(selectLoadingUser);

  useEffect(() => {
    // Load the user
    dispatch(getAnonymousUserAction());
  }, [dispatch]);

  if (loading || !userId) {
    return (
      <LoadingGrid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress />
      </LoadingGrid>
    );
  }

  return props.children;
};

export default AnonymousUserWrapper;
